import { useFormatConvertedPrice } from "@/hooks/shopify-hooks/useFormattedPrice";

/**
 * Calculate discount based on price and compare at price
 * 
 * @param {Object} price
 * @param {string} price.amount
 * @param {string} price.currencyCode
 * @param {Object} compareAtprice
 * @param {string} compareAtprice.amount
 * @param {string} compareAtprice.currencyCode
 * @param {number} [quantity]
 * @returns {Object}
 */
// 根据优惠价格和原价计算折扣

import { useMoney } from '@shopify/hydrogen-react';
const useSalePrice = (price, compareAtprice, quantity = 1) => {
  const { amount: priceAmount, currencyCode } = price;
  const { amount: compareAtpriceAmount } = compareAtprice;
  const compareAtpriceTotal = compareAtpriceAmount * quantity;
  let money = null
  if(compareAtpriceTotal - priceAmount <= 0){
      money =useMoney({
      amount: '0',
      currencyCode
    });
  }else{
    // 使用shopify的useMoney来格式化价格
    money = useMoney({
      amount: compareAtpriceTotal - priceAmount,
      currencyCode: currencyCode
    });
  }

  return useFormatConvertedPrice(money, currencyCode);

};

export default useSalePrice;

